import Sentry from "@similarweb/sentry-logger";

import type { IDiscountConfig } from "app/components/discountCampaign/DiscountBanner/utils/discountConfig";
import { TEAMS } from "app/constants/teamName";

const getIsDiscountActive = (config: IDiscountConfig) => {
    const todayDate = new Date();
    const todayISOString = todayDate.toISOString().slice(0, 10);

    const todayTime = Date.parse(todayISOString);
    const startTime = Date.parse(config.startDate);
    const endTime = Date.parse(config.endDate);

    if (isNaN(todayTime) || isNaN(startTime) || isNaN(endTime)) {
        Sentry.errorTracker({
            message: "Error in getIsDiscountActive parsing dates",
            e: new Error("getIsDiscountActive - Failed to parse one or more dates. Check the YYYY-MM-DD format."),
            level: "error",
            params: {
                tags: { team: TEAMS.GROWTH },
            },
        });
        return false;
    }

    const isAfterOrOnStart = todayTime >= startTime;
    const isBeforeOrOnEnd = todayTime < endTime;

    return isAfterOrOnStart && isBeforeOrOnEnd;
};

export default getIsDiscountActive;
